/**
 * Dismissible site announcement bar (header partial).
 * Persists dismissal in localStorage keyed by message content so a new admin message re-shows the bar.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'lastClosedBannerMessage';

  function init() {
    var bar = document.querySelector('[data-announcement-message]');
    if (!bar) return;

    var messageKey = '';
    try {
      messageKey = decodeURIComponent(bar.getAttribute('data-announcement-message') || '');
    } catch (e) {
      messageKey = bar.getAttribute('data-announcement-message') || '';
    }

    var lastClosed = localStorage.getItem(STORAGE_KEY);
    if (messageKey !== lastClosed) {
      bar.removeAttribute('hidden');
    }

    var dismissBtn = bar.querySelector('[data-announcement-dismiss]');
    if (!dismissBtn) return;

    dismissBtn.addEventListener('click', function () {
      bar.setAttribute('hidden', '');
      localStorage.setItem(STORAGE_KEY, messageKey);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
